module.exports = __webpack_public_path__ + "img/jet6_02.689c798a.jpg";